import { useTranslation } from 'react-i18next';
import { KeyRound } from 'lucide-react';
import ComingSoonPanel from '../components/ComingSoonPanel';

const ApiKeys = () => {
  const { t } = useTranslation('settings');

  return (
    <ComingSoonPanel
      title={t('api.title')}
      description={t('api.comingSoon')}
      notice={t('api.availabilityNotice')}
      icon={KeyRound}
    />
  );
};

export default ApiKeys;
